import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { fmtMoney, fmtDate } from "../lib/format";
import { useActions } from "../components/ActionDialogs";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { Button } from "../components/ui/button";
import { Plus, Wallet, HandCoins } from "lucide-react";

export default function Payments() {
  const [fees, setFees] = useState([]);
  const [collections, setCollections] = useState([]);
  const [clients, setClients] = useState({});
  const { open } = useActions();
  const navigate = useNavigate();

  const load = useCallback(() => {
    api.get("/fees").then(({ data }) => setFees(data));
    api.get("/collections").then(({ data }) => setCollections(data));
    api.get("/clients").then(({ data }) => {
      const m = {}; data.forEach((c) => (m[c.id] = c)); setClients(m);
    });
  }, []);
  useEffect(() => { load(); window.addEventListener("shb:refresh", load); return () => window.removeEventListener("shb:refresh", load); }, [load]);

  const cname = (id) => clients[id]?.name || "—";

  return (
    <div className="space-y-5 animate-in-up">
      <h1 className="font-heading text-2xl md:text-3xl font-bold text-navy-900">Ödemeler</h1>
      <Tabs defaultValue="fees">
        <TabsList className="bg-white border border-slate-200 rounded-xl p-1">
          <TabsTrigger value="fees" data-testid="pay-tab-fees" className="rounded-lg data-[state=active]:bg-navy-900 data-[state=active]:text-white">Vekâlet Ücretleri</TabsTrigger>
          <TabsTrigger value="collections" data-testid="pay-tab-collections" className="rounded-lg data-[state=active]:bg-navy-900 data-[state=active]:text-white">Tahsilatlar</TabsTrigger>
        </TabsList>

        <TabsContent value="fees" className="mt-4">
          <div className="bg-white rounded-2xl border border-slate-200 p-5">
            <div className="flex justify-end mb-2">
              <Button size="sm" variant="ghost" className="text-navy-900" onClick={() => open("fee", { onDone: load })}><Plus className="w-4 h-4 mr-1" />Vekâlet Ücreti Ekle</Button>
            </div>
            {fees.length === 0 ? <p className="text-sm text-slate-400 py-10 text-center">Kayıt yok.</p> : fees.map((f) => (
              <button key={f.id} onClick={() => navigate(`/muvekkiller/${f.client_id}`)} className="w-full flex items-center justify-between py-3 border-b border-slate-100 text-left hover:bg-slate-50 -mx-2 px-2 rounded-lg transition-colors">
                <div className="flex items-center gap-3 min-w-0">
                  <span className="w-9 h-9 rounded-lg bg-slate-100 flex items-center justify-center shrink-0"><Wallet className="w-4 h-4 text-navy-900" /></span>
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-navy-900 truncate">{cname(f.client_id)}</p>
                    <p className="text-xs text-slate-400">Vade {fmtDate(f.due_date)} · {Number(f.remaining) < 0 ? `Fazla Ödeme ${fmtMoney(-Number(f.remaining), f.currency)}` : `Kalan ${fmtMoney(f.remaining, f.currency)}`}</p>
                  </div>
                </div>
                <span className="font-mono text-sm font-semibold text-navy-900">{fmtMoney(f.amount, f.currency)}</span>
              </button>
            ))}
          </div>
        </TabsContent>

        <TabsContent value="collections" className="mt-4">
          <div className="bg-white rounded-2xl border border-slate-200 p-5">
            <div className="flex justify-end mb-2">
              <Button size="sm" variant="ghost" className="text-navy-900" onClick={() => open("collection", { onDone: load })}><Plus className="w-4 h-4 mr-1" />Tahsilat Ekle</Button>
            </div>
            {collections.length === 0 ? <p className="text-sm text-slate-400 py-10 text-center">Kayıt yok.</p> : collections.map((c) => (
              <button key={c.id} onClick={() => navigate(`/muvekkiller/${c.client_id}`)} className="w-full flex items-center justify-between py-3 border-b border-slate-100 text-left hover:bg-slate-50 -mx-2 px-2 rounded-lg transition-colors">
                <div className="flex items-center gap-3 min-w-0">
                  <span className="w-9 h-9 rounded-lg bg-emerald-100 flex items-center justify-center shrink-0"><HandCoins className="w-4 h-4 text-emerald-700" /></span>
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-navy-900 truncate">{cname(c.client_id)}</p>
                    <p className="text-xs text-slate-400">{fmtDate(c.date)} · {c.payment_method || ""}</p>
                  </div>
                </div>
                <span className="font-mono text-sm font-semibold text-emerald-600">+{fmtMoney(c.amount, c.currency)}</span>
              </button>
            ))}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
